module.exports = __webpack_public_path__ + "static/media/monitor.537cb2eb.png";